export default __webpack_public_path__ + "static/media/25120414.57c508d7.jpg";